import * as React from "react"
import "../styles/styles.sass"
import SidebarNavigation from "../components/sidebarNavigation"
import TitleBar from "../components/titleBar"

// Markup
const IconsPage = () => {
  return (
    <main className="lighthouseView iconsView">
      <title>Icons</title>
      <SidebarNavigation />

      <div className="viewWindow">
        <TitleBar title="Icons" actions=""/>

        <div className="viewContent">
          Icons will be here
        </div>
      </div>
    </main>
  )
}

export default IconsPage
